import React from 'react'
import { Typography } from "antd"
import styled from "styled-components"
import moment from 'moment'
import { CheckCircle } from 'react-feather'

import { FlexRow } from "../FlexboxReusables/FlexItems"
import { VerifyExamResponse } from './types'

export const renderValidCertificate = (data: VerifyExamResponse) => (
  <>
    <FlexRow justifyContent="flex-start">
      <Typography.Title level={2}>Das Zertifikat ist gültig.</Typography.Title>
      <StyledCheckIcon size={30}/>
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>Teilnehmer: <b>{data?.participantLastName}, {data?.participantFirstName}</b></Typography.Text>
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>Geboren am: <b>{moment(data?.participantBirthdate).format('DD.MM.YYYY')}</b></Typography.Text>
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>Kursname: <b>{data?.courseName}</b></Typography.Text>
    </FlexRow>
    {data?.courseDescription
      ? (
        <FlexRow justifyContent="flex-start" width='60%' margin='0 0 1em 0'>
          <Typography.Text>Kursbeschreibung: <b>{data?.courseDescription}</b></Typography.Text>
        </FlexRow>
      )
      : null
    }

    <FlexRow justifyContent="flex-start">
      <Typography.Text>
          Prüfung erfolgreich bestanden am: <b>{moment(data?.examFinishedAt).format('DD.MM.YYYY')}</b>
      </Typography.Text>
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>
        Das Zertifikat hat eine Gültigkeit von <b>{data?.examValidityMonths} Monaten</b> und ist somit gültig bis zum: <b>{moment(data?.examFinishedAt).add(data?.examValidityMonths, 'months').format('DD.MM.YYYY')}</b>
      </Typography.Text>
    </FlexRow>
  </>
)

const StyledCheckIcon = styled(CheckCircle)`
  color: green;
  margin-left: 0.5em;
  margin-bottom: 0.5em;
`